import { PatientsFileTabsEnum } from "../../types/types"

type Props = {
  setTab: React.Dispatch<React.SetStateAction<PatientsFileTabsEnum>>
  tab: PatientsFileTabsEnum
}

const activeTabStyle =
  "text-sumo-500 md:text-normal font-bold text-sm px-8 pt-1 border-t-2 border-sumo-500 transition ease-in-out duration-1000"
const inActiveTabStyle =
  "text-slate-400 md:text-normal font-bold text-sm px-8 pt-1"

export const PatientFilesTab = ({ setTab, tab }: Props) => {
  const choseTab = (chosenTab: PatientsFileTabsEnum) => {
    setTab(chosenTab)
  }

  return (
    <div className="flex flex-row text-center items-start border-t">
      {/* <button onClick={() => choseTab(PatientsFileTabsEnum.DATA)}>
        <h1
          className={
            tab === PatientsFileTabsEnum.DATA
              ? activeTabStyle
              : inActiveTabStyle
          }
        >
          Données Patient
        </h1>
      </button> */}
      <button onClick={() => choseTab(PatientsFileTabsEnum.SURVEYS)}>
        <h1
          className={
            tab === PatientsFileTabsEnum.SURVEYS
              ? activeTabStyle
              : inActiveTabStyle
          }
        >
          Données chirurgie
        </h1>
      </button>
    </div>
  )
}
